import { render, staticRenderFns } from "./TdRefundType.vue?vue&type=template&id=73731f34&"
import script from "./TdRefundType.vue?vue&type=script&lang=ts&"
export * from "./TdRefundType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports